export class FaturamentoBrutoVO {

  totalProdutosIncentivados: number;
  totalProdutosIncentivadosAreasInfluencia: number;
  totalProcessamentoDigitais: number;
  totalTecnac: number;
  totalIcms: number;
  totalIpi: number;
}
